import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/mikado/mikado/website/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/mikado/mikado/website/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/runner/work/mikado/mikado/website/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/home/runner/work/mikado/mikado/website/src/components/layout/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitals"] */ "/home/runner/work/mikado/mikado/website/src/components/WebVitals.tsx");
